import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="contact-info">
          <h4>Información de contacto</h4>
          <p>Teléfono: +34 919 466 888</p>
          <p>Email: info@alandalusfeeling.com </p>
          <p>Granada, Spain</p>
        </div>

        <div className="quick-links">
          <h4>Enlaces rápidos</h4>
          <ul>
            <li><a href="/nosotros">Sobre nosotros</a></li>
            <li><a href="/servicios">Servicios</a></li>
            <li><a href="/contacto">Contacto</a></li>
          </ul>
        </div>

        <div className="footer-links">
          <a href="/politica-de-privacidad">Política de privacidad</a>
          <a href="/politica-de-cookies">Política de cookies</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
